import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ElementRef,
  ViewEncapsulation,
  OnDestroy,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  Renderer2,
} from "@angular/core";
// import videojs from "hm-videojs";
import videojs from "video.js";
@Component({
  selector: "hm-ng-video",
  templateUrl: "./hm-ng-video.component.html",
  styleUrls: ["./hm-ng-video.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class HmNgVideoComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild("fileVideoEl") fileVideo: ElementRef;
  @ViewChild("liveVideoEl") liveVideo: ElementRef;
  @Input() fileOptions?: {
    loop: boolean;
    controls: boolean;
    poster: string;
    preload: "auto" | "metadata" | "none";
    sources: {
      src: string;
      type: string;
    }[];
  };
  @Input() liveOptions?: {
    controls: boolean;
    poster: string;
    preload: "auto" | "metadata" | "none";
    sources: {
      src: string;
      type: string;
    }[];
  };
  @Input() autoplay: boolean;
  @Input() videoHeight: number;
  @Input() videoWidth: number;
  @Input() className: string;
  @Input() loadingSrc: string;
  @Input() maxReloadTimes?: number;
  @Input() errorContent?: string;
  @Input() maxLoadTime?: number;

  @Input() exitFullScreen?: boolean;

  @Output() PauseEventListener = new EventEmitter<string>(); // æååè°
  @Output() PlayingEventListener = new EventEmitter<string>(); // å¼å§æ­æ¾åè°
  @Output() WaitingEventListener = new EventEmitter<string>(); // ç¼å²åè°
  @Output() ErrorEventListener = new EventEmitter<string>(); // éè¯¯åè°
  @Output() DataLoadedEventListener = new EventEmitter<string>(); // æ°æ®å è½½å®æåè°
  @Output() CanPlayEventListener = new EventEmitter<string>(); // å¯ä»¥æ­æ¾åè°
  @Output() ReLoadVideoEventListener = new EventEmitter<string>(); // éæ°å è½½

  @Output() FullScreenToggeleEventListener = new EventEmitter<boolean>(); // åæ¢å¨å±

  public liveLoaded = false;
  private filePlayer: videojs.Player;
  private livePlayer: videojs.Player;
  private isVideoBreak: any;
  private isVideoLoadingTimeout: any;

  private fullScreenTimer: any; // çå¬å¨å±

  constructor(private el: ElementRef, public renderer: Renderer2) {}

  public createDom(type: "file" | "live") {
    if (type === "file") {
      this.fileVideo.nativeElement.innerHTML = `<video id='${this.className}-fileVideo' class='video-js vjs-big-play-centered'  controls muted preload='none' x-webkit-airplay='true' webkit-playsinline='isiPhoneShowPlaysinline' playsinline='isiPhoneShowPlaysinline' x5-playsinline='true' x5-video-player-type='h5'></video>`;
    } else {
      const guide =
        `<div class='loading ${this.className}-loading'><img src='` +
        (this.loadingSrc || "") +
        `' alt='' ></div>`;
      const error =
        `<div class='error ${this.className}-error'><span>` +
        (this.errorContent || "") +
        `</span></div>`;
      this.liveVideo.nativeElement.innerHTML =
        `<video id='${this.className}-liveVideo' class='video-js vjs-big-play-centered'  controls muted preload='none' x-webkit-airplay='true' webkit-playsinline='isiPhoneShowPlaysinline' playsinline='isiPhoneShowPlaysinline' x5-playsinline='true' x5-video-player-type='h5'></video>` +
        guide +
        error;
      this.el.nativeElement
        .querySelector(`.${this.className}-error`)
        .addEventListener("click", () => {
          this.setBgVisible("error", false);
          this.createLivePlayer(true);
        });
    }
  }
  public init() {
    this.liveLoaded = false;
    // åªæ­æ¾å¶ä¸­ä¸ç§å°±ä¼ ä¸ç§ç±»åçoption
    if (this.fileOptions) {
      this.createDom("file");
      const fileVideoEl = this.el.nativeElement.querySelector(
        `#${this.className}-fileVideo`
      );
      this.filePlayer = videojs(
        fileVideoEl,
        Object.assign(this.fileOptions, {
          autoplay: this.autoplay,
          errorDisplay: false,
          controlBar: {
            playToggle: true,
            volumePanel: false, // ä¸éè¦éé³æé®
            pictureInPictureToggle: false, // ä¸éè¦ç»ä¸­ç»
            fullscreenToggle: false,
          },
        })
      );

      this.setDefaultProperty(this.filePlayer);
      this.filePlayer.on("error", ($event) => {
        this.ErrorEventListener.emit($event);
        console.log("æä»¶æµåºéäºï¼");
        this.dispose(this.filePlayer);
        this.fileOptions = null;
        this.createLivePlayer(true, true);
      });

      this.filePlayer.on("playing", ($event) => {
        this.PlayingEventListener.emit($event);
        if (!this.livePlayer) {
          this.createLivePlayer(true); // æä»¶æµåç´æ­æµé½å­å¨çæåµä¸ï¼å¦æä¸æ¯èªå¨æ­æ¾ï¼åå¼ºè¡åé èªå¨æ­æ¾çç´æ­æµ
        }
      });
      this.filePlayer.on("pause", ($event) => {
        this.PauseEventListener.emit($event);
      });
    } else {
      this.createLivePlayer(); // å¦ææ²¡ææä»¶æµï¼åæç§è®¾ç½®çæ¯å¦èªå¨æ­æ¾æ§è¡
    }
  }

  // åå»ºç´æ­æµ ,åé¨ä¼ å°±æç§åé¨ä¼ çï¼ä¸ä¼ åæ ¹æ®è°ç¨çå³å®
  public createLivePlayer(isAutoPlay?, isLoading?) {
    if (!this.liveOptions) {
      return;
    }
    this.createDom("live");
    if (isLoading) {
      this.setBgVisible("loading", true);
    }
    const liveVideoEl = this.el.nativeElement.querySelector(
      `#${this.className}-liveVideo`
    );
    let startTime = 0,
      endTime = 0;
    this.livePlayer = videojs(
      liveVideoEl,
      Object.assign(this.liveOptions, {
        autoplay: isAutoPlay ? isAutoPlay : this.autoplay,
        errorDisplay: false,
        liveui: true,
        controlBar: {
          playToggle: true,
          volumePanel: false, // ä¸éè¦éé³æé®
          pictureInPictureToggle: false, // ä¸éè¦ç»ä¸­ç»
          fullscreenToggle: false,
        },
      })
    );
    this.addFullScreen();
    this.setDefaultProperty(this.livePlayer);
    this.livePlayer.on("loadstart", ($event) => {
      console.log("ç´æ­æµå¼å§load");
      startTime = new Date().getTime();
      // this.setBgVisible("loading", true);
      if (!this.isVideoLoadingTimeout) {
        this.isVideoLoadingTimeout = setTimeout(() => {
          if (
            this.livePlayer &&
            this.livePlayer.readyState() !== 3 &&
            this.livePlayer.readyState() !== 4
          ) {
            this.openModal();
            this.ErrorEventListener.emit("overtime");
            console.log("å è½½è¶æ¶ï¼");
          }
        }, this.maxLoadTime || 15000);
      }
    });
    this.livePlayer.on("loadedmetadata", ($event) => {
      endTime = new Date().getTime();
      console.log("ç´æ­æµå è½½æå");
      this.setBgVisible("loading", false);
      this.DataLoadedEventListener.emit(
        Object.assign($event, { bufferTime: endTime - startTime })
      );
    });
    this.livePlayer.on("canplaythrough", ($event) => {
      if (
        this.livePlayer.readyState() === 3 ||
        this.livePlayer.readyState() === 4
      ) {
        setTimeout(() => {
          if (this.filePlayer) {
            this.dispose(this.filePlayer);
          }
          this.liveLoaded = true;
          this.setBgVisible("loading", false);
        }, 1000);

        this.CanPlayEventListener.emit($event);
      }
      console.log(this.livePlayer.readyState(), "canplaythrough");
    });
    this.livePlayer.on("playing", ($event) => {
      console.log("ç´æ­æµæ­£å¨æ­æ¾ï¼");
      this.destroyTimeout();
      this.setBgVisible("loading", false);
      this.PlayingEventListener.emit($event);
    });
    this.livePlayer.on("error", ($event) => {
      this.ErrorEventListener.emit($event);
      console.log("ç´æ­æµåºéäºï¼");
      this.openModal();
    });
    this.livePlayer.on("pause", ($event) => {
      this.PauseEventListener.emit($event);
    });
    this.livePlayer.on("timeupdate", ($event) => {
      if (!this.isVideoBreak) {
        if (
          this.livePlayer.readyState() !== 3 &&
          this.livePlayer.readyState() !== 4
        ) {
          this.WaitingEventListener.emit($event);
          this.isVideoBreak = setTimeout(() => {
            if (
              this.livePlayer &&
              this.livePlayer.readyState() !== 3 &&
              this.livePlayer.readyState() !== 4
            ) {
              this.openModal();
              this.ErrorEventListener.emit("overtime");
              console.log("ç¼å²è¶æ¶ï¼");
            }
          }, this.maxLoadTime || 15000);
        }
      }
    });
  }
  // è·åplayerå®ä¾
  public getFilePlayer() {
    return this.filePlayer || undefined;
  }
  public getLivePlayer() {
    return this.livePlayer || undefined;
  }
  // é»è®¤éç½®
  public setDefaultProperty(player: videojs.Player) {
    player.playsinline(true);
    //player.crossOrigin("anonymous");
  }
  // éæ¯
  public dispose(player: videojs.Player | undefined) {
    if (!player) {
      return;
    }
    if (!player.isDisposed()) {
      player.dispose();
      player = undefined;
    }
  }
  // éæ¯å®æ¶å¨
  public destroyTimeout() {
    clearTimeout(this.isVideoBreak);
    clearTimeout(this.isVideoLoadingTimeout);
    clearInterval(this.fullScreenTimer);
    this.isVideoBreak = undefined;
    this.isVideoLoadingTimeout = undefined;
    this.fullScreenTimer = undefined;
  }
  // å¨é¨éæ¯
  public destroy() {
    this.destroyTimeout();
    this.dispose(this.filePlayer);
    this.dispose(this.livePlayer);
  }
  // ç»å®éè¯¯äºä»¶
  // èªå®ä¹éè¯¯æ¾ç¤ºæ¹å¼
  // 0,1,2,3,4,5
  // MEDIA_ERR_CUSTOMã
  // MEDIA_ERR_ABORTEDãååè¿ç¨è¢«ç¨æ·ä¸­æ­¢
  // MEDIA_ERR_NETWORKãå½ä¸è½½æ¶åçéè¯¯
  // MEDIA_ERR_DECODEãå½è§£ç æ¶åçéè¯¯
  // MEDIA_ERR_SRC_NOT_SUPPORTEDãä¸æ¯æé³é¢/è§é¢
  // MEDIA_ERR_ENCRYPTED // è¢«å å¯

  // éè¯¯å¼¹çª
  public openModal() {
    this.fileOptions = null;
    this.destroy();
    this.setBgVisible("loading", false);
    this.setBgVisible("error", true);
  }
  // è®¾ç½®å è½½èæ¯/éè¯¯èæ¯æ¾ç¤ºéè
  public setBgVisible(type: "loading" | "error", isShow: boolean) {
    const el =
      type === "loading"
        ? this.el.nativeElement.querySelector(`.${this.className}-loading`)
        : this.el.nativeElement.querySelector(`.${this.className}-error`);
    this.renderer.setStyle(el, "display", isShow ? "block" : "none");
  }
  // å¤æ­æ¯iosè®¾å¤
  public isIOS(): boolean {
    const u = navigator.userAgent;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // iosç»ç«¯
    console.log("ios", isIOS);
    return isIOS;
  }
  // æ·»å èªå®ä¹å¨å±åæ­æ¾æé®
  public addFullScreen() {
    const vjsButtonComponent = videojs.getComponent("Button");
    videojs.registerComponent(
      "FullScreenButton",
      videojs.extend(vjsButtonComponent, {
        handleClick: () => {
          if (!this.livePlayer.isFullscreen()) {
            try {
              this.toFullScreen();
              if (this.isIOS()) {
                this.fullScreenTimer = setInterval(() => {
                  if (!this.livePlayer.isFullscreen()) {
                    // éåºäºå¨å±
                    this.FullScreenToggeleEventListener.emit(false);
                    this.destroy();
                    this.createLivePlayer(true);
                    // clearInterval(this.fullScreenTimer);
                    // setTimeout(() => {
                    //   this.livePlayer.play();
                    // }, 1000);
                  }
                }, 1000);
              }
            } catch (error) {
              console.warn(error);
            }
          } else {
            this.FullScreenToggeleEventListener.emit(false);
            this.livePlayer.exitFullscreen();
          }
        },
        buildCSSClass: () => {
          return "my_fullscreen";
        },
      })
    );
    this.livePlayer.getChild("controlBar").addChild("FullScreenButton", {});
  }
  // èªå®ä¹å¨å±
  public toFullScreen() {
    this.FullScreenToggeleEventListener.emit(true);
    if (this.livePlayer.requestFullscreen) {
      return this.livePlayer.requestFullscreen();
    } else if (this.livePlayer.webkitRequestFullScreen) {
      return this.livePlayer.webkitRequestFullScreen();
    } else if (this.livePlayer.mozRequestFullScreen) {
      return this.livePlayer.mozRequestFullScreen();
    } else {
      return this.livePlayer.msRequestFullscreen();
    }
  }

  ngOnInit() {
    console.log("hm-ng-video 1.5.6");
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.exitFullScreen) {
      console.log("æè¿åé®éåºå¨å±");
      this.FullScreenToggeleEventListener.emit(false);
      this.livePlayer.exitFullscreen();
    }
    if (
      (changes.fileOptions &&
        changes.fileOptions.firstChange &&
        changes.fileOptions.currentValue) ||
      (changes.liveOptions &&
        changes.liveOptions.firstChange &&
        changes.liveOptions.currentValue)
    ) {
      this.init();
    }
    if (
      (changes.fileOptions &&
        changes.fileOptions.currentValue &&
        !changes.fileOptions.firstChange) ||
      (changes.liveOptions &&
        changes.liveOptions.currentValue &&
        !changes.liveOptions.firstChange)
    ) {
      this.destroy();
      setTimeout(() => {
        this.init();
      }, 1000);
    }
  }
  ngOnDestroy() {
    this.destroy();
  }
}
